export enum UpcomingFilter {
  Presigning = 'presigning',
  PresigningToday = 'presigning_today',
  PresigningTomorrow = 'presigning_tomorrow'
}
